/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack } from '@mybridge/ui/layout';
import React, { useState,useEffect , useContext } from 'react';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { TeamsContext } from '../teams/context';
import _ from 'lodash';
import { getSelectedRoomMembers } from 'v4/store/actions/global.data.actions';
import { ChatDownArrowIcon } from '@mybridge/icons/ChatDownArrowIcon';
import {
  MemberIcon,
  CalendarChatIcon,
  MeetNow,
  InviteFriends,
  ChangePhoto,
  ExitGroup,
  Edit,
} from '@mybridge/icons';
import styles from './statusProfile.module.scss';
import { VStack } from '@chakra-ui/react';
import { Text } from '@mybridge/ui';
import MemberPopup from './member-popup';
import Link from 'next/link';
import GroupImgUploader from './group-img-uploader';
import BlockedUserPopup from './block-user-popup';
import { useDispatch, useSelector } from 'react-redux';
import ExitGroupPopup from './ExitGroupPopup';
import { useRouter } from 'next/router';
import {
  joinMeeting,
  generateMeetingId,
  scheduleMeetingWithUser,
} from 'v4/store/actions/meeting.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
const GroupChatMsgPopover = ({
  setIsBlockUserModal,
  selectedChat,
  setSelectedChat,
  roomId,
  groupName,
  isBlockUserModal,
  setIsCreateGroupedClicked,
  setIsGroupModalOpen,
  groupMemberDetail,
  isMembersPopupOpen,
  setIsMembersPopupOpen,
  setGroupName,
  setIsgroupNameModal,
  handleExitMessage,
  fetchRoomList,
  getSelectedRoomMembersData,
  onSendMessage,
  teamDetails,
  setRoomId,
  ...props
}) => {
   const chatState = useSelector((state) => state.chat);
  const { userProfileInfo } = useSelector((state) => state?.userProfile);
  const [isMemberPopupOpen, setIsMemberPopupOpen] = useState(false);
  const [isGrpImgUploaderOpen, setIsGrpImgUploaderOpen] = useState(false);
  const [blockedMemberPopup, setBlockedMemberPopup] =useState(false);
  const [isExitGroupPopup, setIsExitGroupPopup] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslator();
  const isAdmin = groupMemberDetail?.some(
    (member) =>
      member?.user_id === userProfileInfo?.id && (member?.role === 'admin'||member?.role === 'owner')
  );

  const currentUserId = userProfileInfo?.id; // Assuming `userProfileInfo` has the current user's ID
  const { matrixClient, loggedInUser, teamsChats, callStatus,initiateMatrixCall } = useContext(MatrixContext);
  const { setChatTeamSlug, chatTeamSlug, isOrganizer, chatRoom, teamMembers, setChatRoom, leaveTeamDisc } =
        useContext(TeamsContext);

        useEffect(() => {
          if (roomId) {
            dispatch(getSelectedRoomMembers(roomId)).then((res) => {
              // console.log("Room members fetched:", res?.payload?.members);
            });
          }
        }, [roomId, dispatch]);

         const handleStartTeamMeeting = async () => {;
              await dispatch(generateMeetingId()).then(async(res) => {
                if (res) {
                  const meetingId = res.payload.meeting_id;
                  const meetingLink = `${process.env.BASE_PUBLIC_URL}meet/${meetingId}`;
          
                  const plainTextMessage = `Let's meet\nPlease join using this link: ${meetingLink} \n Meeting ID: ${meetingId}`;
                  const htmlMessage = `
                    Let's meet<br/>
                    Please join using this link: 
                    <a href="${meetingLink}">${meetingLink}</a><br/>
                    Meeting ID: ${meetingId}
                  `;
          
                  const content = {
                    body: plainTextMessage, 
                    type: 'org.matrix.custom.html', 
                    formatted_body: htmlMessage,  
                    msg_type: 'm.text',  
                  };
          
                  if (onSendMessage) {
                   await onSendMessage(content)
                    dispatch(
                              joinMeeting({
                                created_by: userProfileInfo,
                                meetingId: res.payload.meeting_id,
                                attendees: null,
                                isWaiting: true,
                              })
                            );
                  }
                }
              });
            }

  const handleScheduleMeeting = () => {
    dispatch(
      scheduleMeetingWithUser({
        users: groupMemberDetail,
        type: 'group',
        roomId: selectedChat?.room_id
      })
    );
    router.push(`/profile/calendar/schedule?room=${selectedChat?.room_id}`);
  };
  
  return (
    <Box>
      <Popover placement="bottom-end" isLazy >
      {({ onClose }) => (
        <>
        <PopoverTrigger>
          <button>
            <ChatDownArrowIcon />
          </button>
        </PopoverTrigger>
        <PopoverContent
          marginTop={'0px'}
          padding={'16px'}
          mr={'-50px'}
          backgroundColor="#F9F9F9"
          borderRadius={'16px'}
          className={styles.statusDropdown}
        >
          <PopoverBody
            py={0}
            px={'0px'}
            style={{ outline: 'none', borderRadius: '12px' }}
          >
            <VStack alignItems="start" gap={'16px'}>
              <HStack alignItems="center" cursor="pointer" gap="10px"
              onClick={() => {
                handleStartTeamMeeting();
                onClose(); 
              }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MeetNow color={'#5B5B5B'} width="16" height="16" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('profileNetwork.meetNow') || "Meet now"}
                </Text>
              </HStack>
              
              <HStack cursor="pointer"
              onClick={handleScheduleMeeting}
              // as={Link}
              // href={'/profile/calendar/schedule'}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <CalendarChatIcon color="#5B5B5B" width="18" height="18" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('common.scheduleMeeting') || "Schedule a Meeting"}
                </Text>
              </HStack>

              <HStack cursor="pointer"  onClick={() => setIsMemberPopupOpen(true)}>
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MemberIcon />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('myMessages.members') || "Members"}
                </Text>
              </HStack>
              {isAdmin && (
                <>
                  <HStack
                    cursor="pointer"
                    onClick={() => {
                      setIsGroupModalOpen({ open: true, data: 'edit' });
                      setIsCreateGroupedClicked(true);
                    }}
                  >
                    <Box
                      width="30px"
                      height="30px"
                      backgroundColor="#D9D9D9"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <InviteFriends width="16.01" height="16" />
                    </Box>
                    <Text
                      fontSize="15px"
                      fontWeight={400}
                      lineHeight="30px"
                      fontFamily="Inter"
                      color="#747474"
                    >
                      {t('myMessages.addPeople') || "Add people"}
                    </Text>
                  </HStack>

                  <HStack
                    cursor="pointer"
                    onClick={() => {
                      setBlockedMemberPopup(true);
                    }}
                  >
                    <Box
                      width="30px"
                      height="30px"
                      backgroundColor="#D9D9D9"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <InviteFriends width="16.01" height="16" />
                    </Box>
                    <Text
                      fontSize="15px"
                      fontWeight={400}
                      lineHeight="30px"
                      fontFamily="Inter"
                      color="#747474"
                    >
                      {t('myMessages.blockedMembers') || "Blocked Members"}
                    </Text>
                  </HStack>

                  <HStack
                    cursor="pointer"
                    onClick={() => {
                      setIsGrpImgUploaderOpen(true);
                    }}
                  >
                    <Box
                      width="30px"
                      height="30px"
                      backgroundColor="#D9D9D9"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <ChangePhoto width="18" height="18" />
                    </Box>
                    <Text
                      fontSize="15px"
                      fontWeight={400}
                      lineHeight="30px"
                      fontFamily="Inter"
                      color="#747474"
                    >
                      {t('myMessages.changePhoto') || "Change Photo"}
                    </Text>
                  </HStack>

                  <HStack
                    cursor="pointer"
                    onClick={() => {
                      setGroupName(selectedChat?.room_name);
                      setIsgroupNameModal({ open: true, data: 'edit' });
                    }}
                  >
                    <Box
                      width="30px"
                      height="30px"
                      backgroundColor="#D9D9D9"
                      borderRadius="50%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Edit color="#5B5B5B" width="18" height="18" />
                    </Box>
                    <Text
                      fontSize="15px"
                      fontWeight={400}
                      lineHeight="30px"
                      fontFamily="Inter"
                      color="#747474"
                      textTransform='capitalize'
                    >
                      {t('myMessages.changeGroupName') || "Change Group Name"}
                    </Text>
                  </HStack>
                </>
              )}
              <HStack cursor="pointer"
              onClick={()=>{
                setIsExitGroupPopup(true)
               
              }}
              >
                <Box
                  width="30px"
                  height="30px"
                  backgroundColor="#D9D9D9"
                  borderRadius="50%"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <ExitGroup width="17.92" height="16" />
                </Box>
                <Text
                  fontSize="15px"
                  fontWeight={400}
                  lineHeight="30px"
                  fontFamily="Inter"
                  color="#747474"
                >
                  {t('myMessages.exitGroup') || "Exit Group"}
                </Text>
              </HStack>
            </VStack>
          </PopoverBody>
        </PopoverContent>
        </>
      )}
      </Popover>
      <BlockedUserPopup
        roomId={roomId} 
        fetchRoomList={fetchRoomList} 
        blockedMemberPopup={blockedMemberPopup} 
        setBlockedMemberPopup={setBlockedMemberPopup}
        getSelectedRoomMembersData={getSelectedRoomMembersData} 
      />

      <MemberPopup
        isMemberPopup={isMemberPopupOpen}
        onClose={() => setIsMemberPopupOpen(false)}
        roomId={roomId}
        fetchRoomList={fetchRoomList}
        groupMemberDetail={groupMemberDetail}
        getSelectedRoomMembersData={getSelectedRoomMembersData}
      />
      <GroupImgUploader fetchRoomList={fetchRoomList} setSelectedChat={setSelectedChat} selectedChat={selectedChat} roomId={roomId} groupMemberDetail={groupMemberDetail} isGrpImgUploaderOpen={isGrpImgUploaderOpen} onClose={()=>setIsGrpImgUploaderOpen(false)} setRoomId={setRoomId}/>
      <ExitGroupPopup isAdmin={isAdmin} roomId={roomId} groupMemberDetail={groupMemberDetail} handleExitMessage={handleExitMessage} isExitGroupPopup={isExitGroupPopup} onClose={()=> setIsExitGroupPopup(false)} onAssignAdmin={()=> setIsMemberPopupOpen(true)}/>
    </Box>
  );
};

export default GroupChatMsgPopover;
